<template>
  <div class="verification-details-anchors">
    <template
      v-if="verificationDetails.isNotEmptyAnchors ||
        userDetails.isNotEmptyAnchors">
      <a-divider />
      <div class="verification-details-anchors__section app-key-value__row">
        <template v-if="verificationDetails.isNotEmptyAnchors">
          <a-collapse expand-icon-position="right">
            <a-collapse-panel
              key="verification-details-anchors.key-anchors"
              :header="'verification-details.key-anchors' | globalize">
              <details-reader
                :with-accordion="true"
                :details="verificationDetails.anchors" />
            </a-collapse-panel>
          </a-collapse>
        </template>
        <template v-else>
          <a-collapse expand-icon-position="right">
            <a-collapse-panel
              key="verification-details-anchors.key-anchors"
              :header="'verification-details.key-anchors' | globalize">
              <details-reader
                :with-accordion="true"
                :details="userDetails.anchors" />
            </a-collapse-panel>
          </a-collapse>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import { VerificationRecord } from '@/js/records/entities/verification.record'
import DetailsReader from '@/vue/common/DetailsReader/DetailsReader'
import { UserRecord } from '@/js/records/entities/user.record'
import ADivider from 'ant-design-vue/lib/divider'
import ACollapse from 'ant-design-vue/lib/collapse/Collapse'
import ACollapsePanel from 'ant-design-vue/lib/collapse/CollapsePanel'
import 'ant-design-vue/lib/collapse/style/index.css'

export default {
  name: 'verification-details-anchors',
  components: {
    DetailsReader,
    'a-collapse': ACollapse,
    'a-collapse-panel': ACollapsePanel,
    'a-divider': ADivider,
  },
  props: {
    verificationDetails: {
      type: VerificationRecord,
      required: true,
    },
    userDetails: {
      type: UserRecord,
      required: true,
    },
  },
  data: () => ({
    isAnchorsShown: false,
  }),
}
</script>

<style lang="scss">
@import '~ant-design-vue/lib/divider/style/index.css';

.verification-details-anchors__subtitle {
  margin-bottom: 2rem;
}

.verification-details-anchors__section {
  margin-top: 3rem;
}

.verification-details-anchors__dropdown-btn {
  display: flex;
  justify-content: flex-start;
  margin-top: 1rem;
}

.verification-details-anchors__dropdown-btn-icon {
  display: block;
  font-size: 2rem;
  height: 2rem;
  width: 2rem;
  line-height: 1.8rem;
  transition: all 0.3s;
}
</style>
